// packages/ui-kit/src/health/echarts-init.ts
// ECharts 按需引入 — ADR-0013
// 规格: 仅引入项目所需 chart/component/renderer, 控制 bundle 体积 ~200KB
// 约束: 严禁 import 'echarts' (会引入全量 ~1MB)
import * as echarts from 'echarts/core';
import {
  LineChart,
  GaugeChart,
  BarChart,
  TreeChart,
  CustomChart,
} from 'echarts/charts';
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  DataZoomComponent,
  MarkLineComponent,
  MarkPointComponent,
  TimelineComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

import { elderlyTheme } from './elderly-theme';

// 按需注册 (ADR-0013 / 战役 1 T1-12)
echarts.use([
  // charts
  // - LineChart/GaugeChart/BarChart: VitalsChart/HealthStateGauge/ShapChart/UncertaintyMeter
  // - TreeChart: DecisionPath (AI 决策路径, SaMD 路径 A)
  // - CustomChart: EscalationTimeline/HealthTimeline (ADR-0013 规划)
  LineChart,
  GaugeChart,
  BarChart,
  TreeChart,
  CustomChart,
  // components
  // - TimelineComponent: ADR-0013 要求 (EscalationTimeline/HealthTimeline 时间线)
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  DataZoomComponent,
  MarkLineComponent,
  MarkPointComponent,
  TimelineComponent,
  // renderer
  CanvasRenderer,
]);

// 注册适老化主题 (hssna-elderly)
// 各端可通过 echarts.init(dom, 'hssna-elderly') 应用
echarts.registerTheme('hssna-elderly', elderlyTheme);

export { echarts };
export type { ECharts, EChartsCoreOption } from 'echarts/core';

/** 适老化主题名称 (供 init 使用) */
export const ELDERLY_THEME_NAME = 'hssna-elderly';
